import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../route-guards/services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';
import { AuthenticationService } from 'src/app/authentication/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private authApi: AuthenticationService
  ) { }

  private _refreshSubject: Subject<any> = new Subject<any>();
  private handleExpiredToken() {
    this._refreshSubject.subscribe({
      next: (response) => {
        this.authService.refreshLoggedInToken(response.data.token, response.data.user);
      },
      complete: () => {
        this._refreshSubject = new Subject<any>();
      }
    });
    if (this._refreshSubject.observers.length === 1) {
      this.authApi.refreshToken(this.authService.getRefreshTokenRequestBody()).subscribe(this._refreshSubject);
    }

    return this._refreshSubject;
  }

  attachAccessToken(req: HttpRequest<any>) {
    if (this.authService.isAuthenticated() && this.authService.token) {
      req = req.clone({
        setHeaders: {
          ['x-access-token']: this.authService.token
        }
      });
    }

    return req;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    req = this.attachAccessToken(req);
    return next.handle(req).pipe(
      catchError((error, caught) => {
        if (error instanceof HttpErrorResponse && error.error.errorCode === 'AUTH-007-401') {
          return this.handleExpiredToken().pipe(
            switchMap(() => {
              return next.handle(this.attachAccessToken(req));
            })
          );
        } else if (error instanceof HttpErrorResponse && error.error.errorCode === 'AUTH-010-403') {
          this.authService.duplicateLogin();
          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    );
  }

}
